module.exports = __webpack_public_path__ + "img/Beatport.003c9c86.svg";